import {
    Button,
    ListItemText,
    MenuItem,
    Tooltip,
    Typography
} from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { downloadInformeSiniestralidad } from "../../../redux/actions/denuncia";
import { downloadFile } from "../../../util/files";
import { StyledEstablecimientos } from "../../styled/Prevencion";

const ExportSinietralidadButton = ({ disabled, fechaDesde, fechaHasta }) => {
    const dispatch = useDispatch();
    const [openMenu, setOpenMenu] = useState(null);

    const handleClose = (event) => {
        setOpenMenu(null);
    };

    const handleClickMenu = (event) => {
        setOpenMenu(event.currentTarget);
    };

    const handleClickDownloadFile = (type) => {
        dispatch(downloadInformeSiniestralidad(type, fechaDesde, fechaHasta))
            .then((res) => {
                downloadFile(res.value.data, res.value.fileName);
            })
            .catch((err) => {
                toast.error(err);

            });
    }

    return (
        <>
            <StyledEstablecimientos.ButtonContainer>
                <Tooltip title="Exportar" arrow>
                    <span>
                        <Button
                            size="medium"
                            color="primary"
                            variant="contained"
                            onClick={handleClickMenu}
                            disabled={disabled}
                            type="submit"
                        >
                            <Typography>
                                Siniestralidad
                            </Typography>
                        </Button>
                    </span>
                </Tooltip>
            </StyledEstablecimientos.ButtonContainer>
            <StyledEstablecimientos.Menu
                id="simple-menu"
                anchorEl={openMenu}
                keepMounted
                open={Boolean(openMenu)}
                onClose={handleClose}
            >
                <MenuItem onClick={() => handleClickDownloadFile("csv")}>
                    <ListItemText primary="Descargar CSV" />
                </MenuItem>
                <MenuItem onClick={() => handleClickDownloadFile("xlsx")}>
                    <ListItemText primary="Descargar XLSX" />
                </MenuItem>
                <MenuItem onClick={() => handleClickDownloadFile("xls")} >
                    <ListItemText primary="Descargar XLS" />
                </MenuItem>
            </StyledEstablecimientos.Menu>
        </>
    );
};

export default ExportSinietralidadButton;
